export enum CustomerSource {
  RegisteredUser = 0,
  GuestBuyer = 1,
  NewsletterSignup = 2,
  Import = 3,
}

export const customerSourceTranslations: Record<CustomerSource, string> = {
  [CustomerSource.RegisteredUser]: 'customers.source.registered_user',
  [CustomerSource.GuestBuyer]: 'customers.source.guest_buyer',
  [CustomerSource.NewsletterSignup]: 'customers.source.newsletter_signup',
  [CustomerSource.Import]: 'customers.source.import',
};

export const customerSourceOptions = [
  {
    text: customerSourceTranslations[CustomerSource.RegisteredUser],
    val: CustomerSource.RegisteredUser,
  },
  {
    text: customerSourceTranslations[CustomerSource.GuestBuyer],
    val: CustomerSource.GuestBuyer,
  },
  {
    text: customerSourceTranslations[CustomerSource.NewsletterSignup],
    val: CustomerSource.NewsletterSignup,
  },
  {
    text: customerSourceTranslations[CustomerSource.Import],
    val: CustomerSource.Import,
  },
];
